export default __webpack_public_path__ + "static/banner-tips-to-help-you-become-a-super-saver-64d93896c98b5b3af70edea906a2404e.webp";